import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'PROPERTY_REVIEW' });



// WEBPACK FOOTER //
// ./src/frontend/modules/content/property-review/handlers.js